<template lang="pug">
  .avatar(:style="{ boxShadow: '0 0 0 15px ' + borderColor }", :data-initial="person.initial", :class="person.hex_color")
    img(v-if="person.profile_photo_url", :src="person.profile_photo_url")

</template>

<script>

export default {
  name: 'avatar',
  props: ['person', 'borderColor'],
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
@import('../assets/styles/_constants.styl')
.avatar
  border 3px solid #fff
  display inline-block
  vertical-align middle
  &[data-initial]
    position: relative
    text-align: center
    &:before
      color #fff
      content attr(data-initial)
      font-size 24px
      font-weight 400
      height 100%
      left 0
      line-height 46px
      position absolute
      text-align center
      text-transform uppercase
      top 0
      width 100%
      z-index 0
  img
    height 100%
    max-height 100%
    max-width 100%
    position relative
    width 100%
    vertical-align top
    object-fit cover
    //z-index 2
  &.color1
    background-color color-1
  &.color2
    background-color color-2
  &.color3
    background-color color-3
  &.color4
    background-color color-4
  &.color5
    background-color color-5

</style>



// WEBPACK FOOTER //
// Avatar.vue?044b5e83